module.exports = __webpack_public_path__ + "media/38.aa058b1a.mp3";